import { Box, Typography } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useEffect } from 'react';
import { CreditSummary } from '../../../../app/services/api/generated';
import useCurrencyCodeConfiguration from '../../../../hooks/configurations/useCurrencyCodeConfiguration';
import { applyRoundAndFormat } from '../../../../utils';

interface FinanceHeadlineProps {
  creditsThisMonth: CreditSummary[];
  creditsLastMonth: CreditSummary[];
}

const FinanceHeadline = ({ creditsThisMonth, creditsLastMonth }: FinanceHeadlineProps) => {
  const { currencyCode, getCurrencyCodeConfiguration } = useCurrencyCodeConfiguration();

  useEffect(() => {
    getCurrencyCodeConfiguration();
  }, []);

  const currentMonthFinance = creditsThisMonth.reduce((sum, c) => sum + (c.value || 0), 0);
  const previousMonthFinance = creditsLastMonth.reduce((sum, c) => sum + (c.value || 0), 0);
  const change = currentMonthFinance - previousMonthFinance;
  const percentChange = previousMonthFinance === 0 ? 0 :
    (change / previousMonthFinance) * 100;
  const isPositive = change <= 0;

  return (
    <Box
      sx={{
        minWidth: '150px', textAlign: 'center', padding: '16px',
      }}>
      <Typography color="text.secondary"
        gutterBottom>
        Credits
      </Typography>
      <Typography component="h3"
        sx={{ fontWeight: 900, color: 'primary.main', my: 1 }}>
        {applyRoundAndFormat(currentMonthFinance / 1000, currencyCode)}k
      </Typography>
      <Box display="flex"
        alignItems="center"
        justifyContent="center"
        mt={1}>
        {isPositive ? (
          <ArrowUpwardIcon color="success"
            fontSize="small" />
        ) : (
          <ArrowDownwardIcon color="error"
            fontSize="small" />
        )}
        <Typography component="div"
          color={isPositive ? 'success.main' : 'error.main'}
          sx={{ ml: 0.5 }}>
          {isPositive ? '+' : ''}{percentChange.toFixed(1)}%
        </Typography>
      </Box>
      <Typography component="div"
        color="text.secondary"
        sx={{ ml: 0.5 }}>
        vs last month
      </Typography>
    </Box>
  );
};

export default FinanceHeadline;
